import { LobbyGameParams } from "~/business/LobbyGameParams";
import { LobbyGame } from "~/utils";

export const getLobbyGameParams = (
  lobbyGame?: LobbyGame
): LobbyGameParams | undefined => {
  const { settings } = lobbyGame ?? {};
  const { params } = settings ?? {};
  const paramsParsed = params ? LobbyGameParams.fromRecord(params) : undefined;
  return paramsParsed;
};
